/*
 * Immersive product page:
 *  - forces full-resolution media (Dawn's `sizes` attr is for the 2-col layout)
 *  - builds a self-contained glass nav pill (prev / dots / next) that drives the
 *    media slider directly
 *  - adds a bag icon to Add-to-cart and a custom "Compra ora" (buy now) button
 *    that adds to cart then jumps to checkout (works regardless of store settings)
 *  Runs only on product pages (script loaded conditionally in theme.liquid).
 */
(function () {
  var CHEVRON =
    '<svg viewBox="0 0 10 16" width="10" height="16" aria-hidden="true" focusable="false">' +
    '<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
    'stroke-linejoin="round" d="M8 1 1.5 8 8 15"/></svg>';

  var BAG_ICON =
    '<svg class="pi-bag-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M6 8h12l-1 12H7L6 8Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
    '<path d="M9 8V6a3 3 0 0 1 6 0v2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  var BUY_NOW_ICON =
    '<svg class="pi-buy-now-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>';

  function makeArrow(kind, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pi-arrow pi-arrow--' + kind;
    b.setAttribute('aria-label', label);
    b.innerHTML = CHEVRON;
    return b;
  }

  /* -------- Media nav pill (prev / dots / next) -------- */
  function initGalleryNav() {
    var mediaWrapper = document.querySelector('.product__media-wrapper');
    var list = document.querySelector('.product__media-wrapper .product__media-list');
    if (!mediaWrapper || !list) return;
    if (mediaWrapper.querySelector('.pi-nav')) return;

    // Full-bleed media needs a full-width source candidate.
    var imgs = list.querySelectorAll('img');
    for (var n = 0; n < imgs.length; n++) {
      imgs[n].setAttribute('sizes', '100vw');
    }

    // Hide Dawn's native slider buttons — we render our own.
    var dawnButtons = mediaWrapper.querySelector('.slider-buttons');
    if (dawnButtons) dawnButtons.style.display = 'none';

    var slides = list.querySelectorAll('.product__media-item');
    if (slides.length <= 1) return;

    var nav = document.createElement('div');
    nav.className = 'pi-nav';
    var prev = makeArrow('prev', 'Previous image');
    var dots = document.createElement('div');
    dots.className = 'pi-dots';
    for (var i = 0; i < slides.length; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pi-dot';
      dot.dataset.index = i;
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
      dots.appendChild(dot);
    }
    var next = makeArrow('next', 'Next image');
    nav.appendChild(prev);
    nav.appendChild(dots);
    nav.appendChild(next);
    mediaWrapper.appendChild(nav);

    var dotEls = dots.querySelectorAll('.pi-dot');
    function reduceMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    function currentIndex() {
      var w = list.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(list.scrollLeft / w)));
    }
    function goTo(idx) {
      idx = Math.max(0, Math.min(slides.length - 1, idx));
      list.scrollTo({ left: idx * list.clientWidth, behavior: reduceMotion() ? 'auto' : 'smooth' });
    }
    function setActive() {
      var idx = currentIndex();
      for (var j = 0; j < dotEls.length; j++) {
        dotEls[j].classList.toggle('pi-dot--active', j === idx);
      }
      prev.disabled = idx <= 0;
      next.disabled = idx >= slides.length - 1;
    }
    prev.addEventListener('click', function () {
      goTo(currentIndex() - 1);
    });
    next.addEventListener('click', function () {
      goTo(currentIndex() + 1);
    });
    dots.addEventListener('click', function (event) {
      var target = event.target.closest('.pi-dot');
      if (!target) return;
      goTo(parseInt(target.dataset.index, 10) || 0);
    });
    var ticking = false;
    list.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          setActive();
        });
      },
      { passive: true }
    );
    window.addEventListener('resize', setActive);
    setActive();
  }

  /* -------- Buy buttons: bag icon + custom "Compra ora" -------- */
  function ensureBuyButtons() {
    var card = document.querySelector('.product__info-container');
    if (!card) return;
    var submit = card.querySelector('.product-form__submit');
    var buttonsWrap = card.querySelector('.product-form__buttons');
    if (!submit || !buttonsWrap) return;

    if (!submit.querySelector('.pi-bag-icon')) {
      submit.insertAdjacentHTML('afterbegin', BAG_ICON);
    }
    if (!buttonsWrap.querySelector('.pi-buy-now')) {
      var buyNow = document.createElement('button');
      buyNow.type = 'button';
      buyNow.className = 'pi-buy-now';
      buyNow.innerHTML = BUY_NOW_ICON + '<span>Buy now</span>';
      buttonsWrap.appendChild(buyNow);
    }
    if (!buttonsWrap.querySelector('.pi-notify-wrap')) {
      var wrap = document.createElement('div');
      wrap.className = 'pi-notify-wrap';
      wrap.innerHTML =
        '<button type="button" class="pi-notify">Notify me when available</button>' +
        '<form class="pi-notify-form" hidden>' +
        '<input type="email" class="pi-notify-email" placeholder="Your email" required>' +
        '<button type="submit" class="pi-notify-send">Send</button>' +
        '</form>' +
        '<p class="pi-notify-message" hidden></p>';
      buttonsWrap.appendChild(wrap);
    }
    // Sold out / unavailable → Dawn disables the add-to-cart button.
    buttonsWrap.classList.toggle('pi-soldout', submit.hasAttribute('disabled'));
  }

  // Move the colour selector and the quantity stepper onto one row.
  function ensureOptionsRow() {
    var card = document.querySelector('.product__info-container');
    if (!card) return;
    var variants = card.querySelector('variant-selects');
    var quantity = card.querySelector('.product-form__quantity');
    if (!variants || !quantity) return;
    var row = card.querySelector('.pi-options-row');
    if (row && row.contains(variants) && row.contains(quantity)) return;
    if (!row) {
      row = document.createElement('div');
      row.className = 'pi-options-row';
      variants.parentNode.insertBefore(row, variants);
    }
    row.appendChild(variants);
    row.appendChild(quantity);
  }

  function ensureCard() {
    ensureBuyButtons();
    ensureOptionsRow();
  }

  var buyObserverStarted = false;
  function observeBuyButtons() {
    if (buyObserverStarted || !window.MutationObserver) return;
    var target = document.querySelector('product-info') || document.querySelector('.product__info-container');
    if (!target) return;
    buyObserverStarted = true;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        ensureCard();
      });
    }).observe(target, { childList: true, subtree: true });
  }

  function handleBuyNow(btn) {
    if (btn.disabled || btn.classList.contains('loading')) return;
    var card = btn.closest('.product__info-container') || document.querySelector('.product__info-container');
    if (!card) return;
    var idInput = card.querySelector('form [name="id"]');
    var variantId = idInput && idInput.value;
    if (!variantId) return;
    var qtyInput = card.querySelector('.quantity__input');
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    btn.classList.add('loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add-to-cart failed');
        return r.json();
      })
      .then(function () {
        window.location.href = root + 'checkout';
      })
      .catch(function () {
        btn.classList.remove('loading');
      });
  }

  function handleNotifySubmit(form) {
    var wrap = form.closest('.pi-notify-wrap');
    var emailInput = form.querySelector('.pi-notify-email');
    var email = emailInput && emailInput.value;
    if (!email) return;

    var card = form.closest('.product__info-container') || document.querySelector('.product__info-container');
    var titleEl = card && card.querySelector('.product__title');
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : document.title;
    var idInput = card && card.querySelector('form [name="id"]');
    var variantId = idInput ? idInput.value : '';
    var msg = wrap && wrap.querySelector('.pi-notify-message');
    var sendBtn = form.querySelector('.pi-notify-send');
    if (sendBtn) sendBtn.disabled = true;

    var fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[body]', 'Notify me when available — ' + title + ' (variant ' + variantId + ')');

    fetch('/contact', { method: 'POST', body: fd })
      .then(function () {
        form.hidden = true;
        if (msg) {
          msg.hidden = false;
          msg.textContent = 'Perfetto! Ti avviseremo appena torna disponibile.';
        }
      })
      .catch(function () {
        if (sendBtn) sendBtn.disabled = false;
        if (msg) {
          msg.hidden = false;
          msg.textContent = 'Qualcosa è andato storto, riprova.';
        }
      });
  }

  function initImmersive() {
    if (!document.body.classList.contains('product-immersive')) return;
    initGalleryNav();
    ensureCard();
    observeBuyButtons();
  }

  // Delegated interactions (survive Dawn re-renders).
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var buy = event.target.closest('.pi-buy-now');
    if (buy) {
      event.preventDefault();
      handleBuyNow(buy);
      return;
    }
    var notify = event.target.closest('.pi-notify');
    if (notify) {
      event.preventDefault();
      var wrap = notify.closest('.pi-notify-wrap');
      var form = wrap && wrap.querySelector('.pi-notify-form');
      if (form) {
        form.hidden = false;
        var focusEmail = form.querySelector('.pi-notify-email');
        if (focusEmail) focusEmail.focus();
      }
      notify.hidden = true;
      return;
    }
    // Final-CTA buttons → jump back to the hero buy card
    var scrollBtn = event.target.closest('[data-pdp-scroll-to-buy]');
    if (scrollBtn) {
      event.preventDefault();
      var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      var card = document.querySelector('.product__info-container');
      if (card && card.scrollIntoView) {
        card.scrollIntoView({ behavior: behavior, block: 'center' });
      } else {
        window.scrollTo({ top: 0, behavior: behavior });
      }
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('.pi-notify-form');
    if (!form) return;
    event.preventDefault();
    handleNotifySubmit(form);
  });

  if (document.readyState !== 'loading') {
    initImmersive();
  } else {
    document.addEventListener('DOMContentLoaded', initImmersive);
  }

  document.addEventListener('shopify:section:load', initImmersive);
})();
